// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Movements_container__Tps3Z {
  animation: Movements_init__6--mR 1s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  font-size: 16px;
}

.Movements_container__Tps3Z .Movements_data__j5tuo {
  animation: Movements_init3__TjVv6 0.5s both;
}

/*----Table container-----*/
.Movements_container__Tps3Z .Movements_data__j5tuo .Movements_tableContainer__KsvzI {
  animation: Movements_init2__olha8 0.5s both;
  border-radius: 10px;
  max-height: 80vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
  margin-top: 30px;
}

.Movements_container__Tps3Z .Movements_header__AVXVe {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Movements_container__Tps3Z .Movements_titleContainer__Di6Mo {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 2%;
}

.Movements_container__Tps3Z .Movements_titleContainer__Di6Mo h4 {
  animation: Movements_init2__olha8 0.5s both;
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin: 0;
}

.Movements_container__Tps3Z .Movements_titleContainer__Di6Mo .Movements_arrow__2xxsc {
  animation: Movements_init1__bDj8N 0.5s both;
  transition: 0.3s;
}

.Movements_container__Tps3Z .Movements_titleContainer__Di6Mo .Movements_arrow__2xxsc:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.Movements_container__Tps3Z .Movements_loader__YJD\\+i {
  animation: Movements_init__6--mR 0.3s both;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8rem;
  font-weight: 300;
}

.Movements_init__6--mR {
  animation: Movements_init1__bDj8N 0.5s 0.5s both;
}

@keyframes Movements_init1__bDj8N {
  0% {
    opacity: 0;
    transform: translateX(-50px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes Movements_init2__olha8 {
  0% {
    opacity: 0;
    transform: translateX(50px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes Movements_init3__TjVv6 {
  0% {
    opacity: 0;
    top: -100px;
  }
  100% {
    opacity: 1;
    top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Cupones/Movements/Movements.module.css"],"names":[],"mappings":"AAAA;EACE,mCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2CAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,2CAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2CAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,2CAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0CAAyB;EACzB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gDAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,UAAU;IACV,MAAM;EACR;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  font-size: 16px;\n}\n\n.container .data {\n  animation: init3 0.5s both;\n}\n\n/*----Table container-----*/\n.container .data .tableContainer {\n  animation: init2 0.5s both;\n  border-radius: 10px;\n  max-height: 80vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n  margin-top: 30px;\n}\n\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 2%;\n}\n\n.container .titleContainer h4 {\n  animation: init2 0.5s both;\n  width: 100%;\n  text-align: center;\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin: 0;\n}\n\n.container .titleContainer .arrow {\n  animation: init1 0.5s both;\n  transition: 0.3s;\n}\n\n.container .titleContainer .arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.container .loader {\n  animation: init 0.3s both;\n  height: 400px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.8rem;\n  font-weight: 300;\n}\n\n.init {\n  animation: init1 0.5s 0.5s both;\n}\n\n@keyframes init1 {\n  0% {\n    opacity: 0;\n    transform: translateX(-50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateX(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n@keyframes init3 {\n  0% {\n    opacity: 0;\n    top: -100px;\n  }\n  100% {\n    opacity: 1;\n    top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Movements_container__Tps3Z`,
	"init": `Movements_init__6--mR`,
	"data": `Movements_data__j5tuo`,
	"init3": `Movements_init3__TjVv6`,
	"tableContainer": `Movements_tableContainer__KsvzI`,
	"init2": `Movements_init2__olha8`,
	"header": `Movements_header__AVXVe`,
	"titleContainer": `Movements_titleContainer__Di6Mo`,
	"arrow": `Movements_arrow__2xxsc`,
	"init1": `Movements_init1__bDj8N`,
	"loader": `Movements_loader__YJD+i`
};
export default ___CSS_LOADER_EXPORT___;
